import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from './ContextoAuth'

interface Props {
    children: ReactNode
    /** Permiso exigido. Sin el, basta con estar autenticado. */
    permiso?: string
}

export function RutaProtegida({ children, permiso }: Props) {
    const { usuario, cargando, puede } = useAuth()
    const ubicacion = useLocation()

    if (cargando) {
        return (
            <div className="fila centro" style={{ minHeight: '100dvh' }}>
                <span className="cargando" aria-label="Cargando" />
            </div>
        )
    }

    if (!usuario) {
        // Se recuerda a donde iba para volver ahi despues de entrar.
        return <Navigate to="/entrar" state={{ destino: ubicacion.pathname }} replace />
    }

    if (permiso && !puede(permiso)) {
        return (
            <div className="panel" style={{ margin: 'var(--e5)' }}>
                <h2>Sin acceso</h2>
                <p className="tenue">
                    Su usuario no tiene permiso para esta pantalla. Pida a un administrador
                    que le asigne el permiso <code>{permiso}</code>.
                </p>
            </div>
        )
    }

    return <>{children}</>
}
